export default __webpack_public_path__ + "static/media/new-moon.a1fa2ef4.svg";